export enum CarePeriodCareType {
  PREVENTIVE = 'PREVENTIVE',
  SHORT_TERM = 'SHORT_TERM',
  SHORT_TERM_WITHOUT_SURCHARGE_43B = 'SHORT_TERM_WITHOUT_SURCHARGE_43B',
  TRANSITIONAL = 'TRANSITIONAL',
  FULL_TIME = 'FULL_TIME',
}
